import React, { useEffect, useState, memo } from "react";
import clockIcon from "../../../assets/images/clock-icon.svg";
import grillIcon from "../../../assets/images/grill-icon.svg";
import markIcon from "../../../assets/images/mark-icon.svg";
import cave from "../../../assets/images/cave.svg";
import gear from "../../../assets/images/gear.svg";
import message from "../../../assets/images/message.svg";
import Slider from "react-slick";

const ServiceValue = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
    swipeToSlide: true,
    lazyLoad: true,
  };

  return (
    <div className="flex flex-col items-center justify-center gap-[30px] w-full h-screen mx-auto">
      <div className="flex flex-col items-center gap-[5px]">
        <p className="text-white text-2xl font-semibold">
          Learn How SERPs Delivers Value
        </p>
        <p className="text-[#e0e0e0] text-[15px] font-medium text-center">
          SERPs is more than a tool. It’s an SEO operating system.
        </p>
      </div>
      <Slider
        {...settings}
        className="md:max-w-[400px] lg:max-w-[480px] max-w-[100%] w-full"
      >
        <div className="flex items-start justify-center gap-[29px] pl-[20px] pr-[20px]">
          <div className="flex items-center gap-5 mb-[29px] p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[61px] h-[61px] object-cover"
              alt="Clock"
              src={clockIcon}
            />
            <div className="flex flex-col">
              <div className="text-[#d2b6fb] text-xl font-bold">Save Time</div>
              <p className="text-white text-xs font-normal">
                Tired of your painstaking and tedious Local SEO tasks? Not
                anymore.
              </p>
            </div>
          </div>
          <div className="flex items-center mb-[29px] gap-5 p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[61px] h-[61px] object-cover"
              alt="Grill"
              src={grillIcon}
            />
            <div className="flex flex-col">
              <div className="text-[#78aef6] text-xl font-bold">Efficiency</div>
              <p className="text-white text-xs font-normal">
                Accelerate your Local SEO campaigns with elite systems,
                processes and automation.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-5 p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[65px] h-[65px] object-cover"
              alt="Mark"
              src={markIcon}
            />
            <div className="flex flex-col">
              <div className="text-[#ffd8b5] text-xl font-bold">
                Predictable, Lasting Results
              </div>
              <p className="text-white text-xs font-normal">
                White hat strategies executed not only efficiently, but at the
                highest level.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-start justify-center gap-[29px] pl-[20px] pr-[20px]">
          <div className="flex items-center mb-[29px] gap-5 p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[61px] h-[61px] object-cover"
              alt="Clock"
              src={cave}
            />
            <div className="flex flex-col">
              <div className="text-[#FABFD4] text-xl font-bold">
                Elite Tech Stack
              </div>
              <p className="text-white text-xs font-normal">
                Have a favorite theme? No problem. SERPs integrates seamlessly
                with your existing workflows.
              </p>
            </div>
          </div>
          <div className="flex items-center mb-[29px] gap-5 p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[61px] h-[61px] object-cover"
              alt="Grill"
              src={gear}
            />
            <div className="flex flex-col">
              <div className="text-[#B1EDDD] text-xl font-bold">Boost MRR</div>
              <p className="text-white text-xs font-normal">
                Your roadmap to millions of annual recurring revenue from Local
                SEO services.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-5 p-[25px] w-full bg-[#182733] rounded-[10px] border-2 border-[#2f3944]">
            <img
              className="w-[65px] h-[65px] object-cover"
              alt="Mark"
              src={message}
            />
            <div className="flex flex-col">
              <div className="text-[#B4E182] text-xl font-bold">
                Client Retention
              </div>
              <p className="text-white text-xs font-normal">
                SERPs.com enhances client retention by delivering consistent SEO
                successes.
              </p>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default memo(ServiceValue);
